import { inject, Injectable, NgZone, signal } from '@angular/core';
import { Router } from '@angular/router';

const OFFLINE_ROUTE = '/offline-routes';

@Injectable({ providedIn: 'root' })
export class OfflineDetectionService {
  private router = inject(Router);
  private ngZone = inject(NgZone);
  private started = false;

  public readonly isOnline = signal<boolean>(typeof navigator === 'undefined' ? true : navigator.onLine);

  private readonly onOffline = () => {
    this.ngZone.run(() => {
      this.isOnline.set(false);
      if (this.router.url.startsWith(OFFLINE_ROUTE)) return;
      this.router.navigateByUrl(OFFLINE_ROUTE);
    });
  };

  private readonly onOnline = () => {
    this.ngZone.run(() => this.isOnline.set(true));
  };

  start(): void {
    if (this.started || typeof window === 'undefined') return;
    this.started = true;

    window.addEventListener('offline', this.onOffline);
    window.addEventListener('online', this.onOnline);

    if (!navigator.onLine) {
      this.onOffline();
    }
  }

  stop(): void {
    if (!this.started) return;
    window.removeEventListener('offline', this.onOffline);
    window.removeEventListener('online', this.onOnline);
    this.started = false;
  }
}
